import { render, staticRenderFns } from "./AssignCompanyTable.vue?vue&type=template&id=75728094&"
import script from "./AssignCompanyTable.vue?vue&type=script&lang=js&"
export * from "./AssignCompanyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports